import { DOMAIN } from '../constants';

export const clsPrefix = 'cap-ask-aira-rule-summarization-bot';

export const ASK_AIRA_ENDPOINT = `${DOMAIN}/arya/api/v1/ask-aira-service`;

export const GET_RULE_REQUEST = 'library/CapAskAira/GET_RULE_REQUEST';
export const GET_RULE_SUCCESS = 'library/CapAskAira/GET_RULE_SUCCESS';
export const GET_RULE_FAILURE = 'library/CapAskAira/GET_RULE_FAILURE';
export const GET_RULE_SUMMARIZE_REQUEST =
  'library/CapAskAira/GET_RULE_SUMMARIZE_REQUEST';
export const GET_RULE_SUMMARIZE_SUCCESS =
  'library/CapAskAira/GET_RULE_SUMMARIZE_SUCCESS';
export const GET_RULE_SUMMARIZE_FAILURE =
  'library/CapAskAira/GET_RULE_SUMMARIZE_FAILURE';

export const RESET_RULE = 'library/CapAskAira/RESET_RULE';

export const UPDATE_LIKE_ANSWER_REQUEST_RULE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_REQUEST_RULE';
export const UPDATE_LIKE_ANSWER_SUCCESS_RULE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_SUCCESS_RULE';
export const UPDATE_LIKE_ANSWER_FAILURE_RULE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_FAILURE_RULE';

export const UPDATE_DISLIKE_ANSWER_REQUEST_RULE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_REQUEST_RULE';
export const UPDATE_DISLIKE_ANSWER_SUCCESS_RULE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_SUCCESS_RULE';
export const UPDATE_DISLIKE_ANSWER_FAILURE_RULE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_FAILURE_RULE';

export const UPDATE_LIKE_ANSWER_REQUEST_SUMMARIZE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_REQUEST_SUMMARIZE';
export const UPDATE_LIKE_ANSWER_SUCCESS_SUMMARIZE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_SUCCESS_SUMMARIZE';
export const UPDATE_LIKE_ANSWER_FAILURE_SUMMARIZE =
  'library/CapAskAira/UPDATE_LIKE_ANSWER_FAILURE_SUMMARIZE';

export const UPDATE_DISLIKE_ANSWER_REQUEST_SUMMARIZE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_REQUEST_SUMMARIZE';
export const UPDATE_DISLIKE_ANSWER_SUCCESS_SUMMARIZE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_SUCCESS_SUMMARIZE';
export const UPDATE_DISLIKE_ANSWER_FAILURE_SUMMARIZE =
  'library/CapAskAira/UPDATE_DISLIKE_ANSWER_FAILURE_SUMMARIZE';

export const REQUEST = 'REQUEST';
export const COMPLETE = 'COMPLETE';
export const IDLE = 'IDLE';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const RULE_SUMMARIZATION_REDUCER_DOMAIN =
  'RULE_SUMMARIZATION_REDUCER_DOMAIN';

export const RULE = 'RULE';
export const SUMMARIZE = 'SUMMARIZE';

export const MESSAGE_LIKE = 'MESSAGE_LIKE';
export const MESSAGE_DISLIKE = 'MESSAGE_DISLIKE';
